// El backend serializa los timestamps en UTC (sufijo Z). La empresa opera en
// Argentina (UTC-3 fijo), así que mostramos SIEMPRE en hora argentina con zona
// FIJA — no la del navegador — para que un operario en otra zona vea igual la
// hora real de la operación. Las fechas "peladas" YYYY-MM-DD (sin hora) son
// fechas de negocio y se muestran tal cual, sin reinterpretar como UTC.
const TZ = 'America/Argentina/Buenos_Aires'
const SOLO_FECHA = /^\d{4}-\d{2}-\d{2}$/

const FMT_FECHA = new Intl.DateTimeFormat('es-AR', { timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric' })
const FMT_FECHA_HORA = new Intl.DateTimeFormat('es-AR', { timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false })
const FMT_ISO = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' })

export function fmtFecha(iso) {
  if (!iso) return '—'
  const s = String(iso)
  if (SOLO_FECHA.test(s)) {
    const [y, m, d] = s.split('-')
    return `${d}/${m}/${y}`
  }
  const dt = new Date(s)
  if (isNaN(dt)) return s
  return FMT_FECHA.format(dt)
}

export function fmtFechaHora(iso) {
  if (!iso) return '—'
  const s = String(iso)
  if (SOLO_FECHA.test(s)) {
    const [y, m, d] = s.split('-')
    return `${d}/${m}/${y}`
  }
  const dt = new Date(s)
  if (isNaN(dt)) return s
  const p = FMT_FECHA_HORA.formatToParts(dt)
  const g = (t) => p.find((x) => x.type === t)?.value || ''
  return `${g('day')}/${g('month')}/${g('year')} ${g('hour')}:${g('minute')}`
}

export function fmtHora(str) {
  if (!str) return '—'
  return str.slice(0, 5)
}

// Hora (HH:MM) en hora argentina de un timestamp ISO — para cuando la fecha ya
// se muestra aparte (ej: la hora del pedido junto a la fecha en /notas-venta).
export function fmtHoraDe(iso) {
  if (!iso) return ''
  const f = fmtFechaHora(iso)
  const partes = f.split(' ')
  return partes.length > 1 ? partes[1] : ''
}

// Convierte un Date al día calendario YYYY-MM-DD en hora argentina (zona fija).
// Reemplaza a toISOString().slice(0,10), que pasa por UTC y a la noche ART
// devuelve el día siguiente.
export function toISOLocal(d) {
  return FMT_ISO.format(d)
}

// Fecha de HOY en YYYY-MM-DD (hora argentina). Para defaults de fecha en formularios.
export function hoyISO() {
  return FMT_ISO.format(new Date())
}

// Importe en formato ARGENTINO: punto de miles, coma decimal ("1.200.000,00").
// Hasta el 3 sep 2026 salía en-US ("1,200,000.00") — Martin lo marcó feo en
// Experiencias y el formato es UNO para toda la app, así que cambió acá.
// `dec` permite mostrar sin centavos donde el decimal es ruido (precios de
// eventos); las pantallas de plata siguen con 2 por defecto.
export function fmtMonto(n, dec = 2) {
  const num = parseFloat(n)
  if (isNaN(num)) return '—'
  return num.toLocaleString('es-AR', { minimumFractionDigits: dec, maximumFractionDigits: dec })
}

export function parseMonto(str) {
  if (!str && str !== 0) return NaN
  const s = String(str).trim()
  // Formato argentino pegado de otro lado ("192.000,50" o "192000,50"): el
  // punto es miles y la coma es decimal. Sin esto, "192.000,00" se leía como
  // 192 y la pantalla marcaba una diferencia gigante que no existía.
  // (coma decimal solo con 1-2 dígitos: "1,500" sigue siendo mil quinientos)
  if (/^-?\d{1,3}(\.\d{3})+(,\d{1,2})?$/.test(s) || /^-?\d+,\d{1,2}$/.test(s)) {
    return parseFloat(s.replace(/\./g, '').replace(',', '.'))
  }
  return parseFloat(s.replace(/,/g, ''))
}
